{
  "accountDeactivatedTitle": "Account Deleted",
  "accountDeactivatedMessage": "This account has been deleted and is no longer active. If you believe this is an error, please contact support.",
  "accountDeactivatedSignOut": "Sign Out",
  "accountLandingLinkTo": "Account",
  "accountLandingTitle": "Account Settings",
  "accountSettingsTitle": "Account Settings",
  "activeFarmTitle": "Active Farm",
  "adminModeToggle": "Admin Mode",
  "adminUser": "Admin User",
  "adminUserIndicatorWithEmail": "{{email}} (Admin User)",
  "appInfoClearCache": "Clear Cache",
  "appInfoExpireFarmCache": "Refresh Farm Data Cache",
  "appInfoExpireFarmCacheSuccess": "Farm data cache refreshed",
  "appInfoIsDemoModeActive": "Demo Mode Enabled",
  "appInfoLinkTo": "App Info",
  "appInfoTitle": "App Info",
  "appInfoUpdateId": "Update ID",
  "appInfoVersion": "Version",
  "appNotificationsLinkTo": "Announcements",
  "appNotificationsListEmpty": "No announcements at this time. Check back later.",
  "appNotificationsTitle": "Announcements",
  "appPreferences": "App Preferences",
  "changeFarmsListActiveDevicesWithItemCount": "{{itemCount}} active devices",
  "changeFarmsListListEmpty": "Your account is not linked to any active farms.",
  "changeFarmsListSubheaderwithFarmName": "Active Farm: {{farmName}}",
  "changeFarmsListTitle": "Your Farm Accounts",
  "checkForUpdatesButtonText": "Check for updates",
  "checkForUpdatesError": "Error fetching latest app update",
  "yourAppIsUpToDate": "Your app is up to date",
  "checkForUpdatesYourAppIsUpToDate": "Your app is up to date",
  "companySectionTitle": "About Us",
  "contactUsLink": "Contact Us",
  "crashButton": "Crash",
  "darkModeToggle": "Dark Mode",
  "exitDemoMode": "Exit Demo",
  "farmJoinCodeTitle": "Farm Join Code",
  "farmUsersListLink": "Farm Users",
  "internalOnlySectionTitle": "Internal Only",
  "linkTo": "Account",
  "measurementPreferenceLabel": "Measurements",
  "measurementPreferenceValues": {
    "metric": "Metric",
    "us": "U.S.A."
  },
  "nameFirstInputLabel": "First Name",
  "nameFirstInputPlaceholder": "(Enter your first name)",
  "nameLastInputLabel": "Last Name",
  "nameLastInputPlaceholder": "(Enter your last name)",
  "newFarmAccount": "New Farm Account",
  "phoneNumbersListLink": "Phone Numbers",
  "shareFeedbackLink": "Share Feedback",
  "supportedLanguages": {
    "en": "🇺🇸 English (USA)",
    "es": "🇲🇽 Spanish (MX)",
    "fr": "🇫🇷 French",
    "it": "🇮🇹 Italian"
  },
  "supportedLanguagesTitle": "Preferred Language",
  "userAccountTitle": "My Account",
  "userFarmsListLinkTo": "Your Farm Accounts",
  "userFarmsListListEmpty": "Your account is not linked to any active farms.",
  "userFarmsListNoOtherFarms": "Your account is not linked to any other farms",
  "userFarmsListSubheaderWithActiveFarmName": "Active Farm: {{activeFarmName}}",
  "userFarmsListTitle": "Your Farm Accounts",
  "userNameFormCollectionDisclaimer": "We collect this information in order to track who our customers are and to provide the best possible customer service experience. We do not share this information with any third parties.",
  "userNameFormCollectionTitle": "Data Collection: User Name",
  "userNameFormInstructions": "In order to provide the best possible customer service experience, we need some information from you:",
  "userNameFormTitle": "User Name",
  "userNameWithNameGivenAndNameFamily": "{{nameGiven}} {{nameFamily}}",
  "viewDebugInfoButton": "View Debug Info",
  "viewFarmUserPermissionsLinkTo": "View Your Permissions",
  "viewFarmUserPermissionsTitle": "Your Permissions",
  "viewPrivacyPolicyLinkTo": "View Privacy Policy",
  "viewPrivacyPolicyTitle": "Privacy Policy",
  "deleteAccountLinkTo": "Delete Account",
  "deleteAccountTitle": "Delete Account",
  "deleteAccountWarning": "This action is permanent and cannot be undone. Your account will be deactivated, your personal information will be removed, and you will be signed out.",
  "deleteAccountConfirmationLabel": "Type DELETE to confirm",
  "deleteAccountConfirmationPlaceholder": "DELETE",
  "deleteAccountConfirmButton": "Delete My Account",
  "deleteAccountOwnedFarmsWarning": "You must transfer ownership or deactivate the following farms before deleting your account:",
  "deleteAccountError": "Unable to delete your account. Please ensure you have transferred ownership or deactivated all farms you own, then try again.",
  "deleteAccountSuccess": "Your account has been deleted.",
  "transferOwnershipLinkTo": "Transfer Ownership",
  "transferOwnershipTitle": "Transfer Farm Ownership",
  "transferOwnershipDescription": "Select a farm member to become the new owner. They will receive full permissions.",
  "transferOwnershipConfirmTitle": "Confirm Transfer",
  "transferOwnershipConfirmMessage": "Transfer ownership of this farm to {{userName}}? This cannot be undone.",
  "transferOwnershipSuccess": "Ownership transferred successfully.",
  "transferOwnershipNoEligibleMembers": "No eligible members to transfer ownership to.",
  "deactivateFarmLinkTo": "Deactivate Farm",
  "deactivateFarmTitle": "Deactivate Farm",
  "deactivateFarmWarning": "This will deactivate the farm, remove all member access, and release all devices. This cannot be undone.",
  "deactivateFarmConfirmationLabel": "Type the farm name to confirm",
  "deactivateFarmConfirmButton": "Deactivate Farm",
  "deactivateFarmDemoBlocked": "The demo farm cannot be deactivated.",
  "deactivateFarmError": "Unable to deactivate the farm. Please verify you typed the farm name correctly and try again.",
  "deactivateFarmSuccess": "Farm has been deactivated.",
  "leaveFarmLinkTo": "Leave Farm",
  "leaveFarmTitle": "Leave Farm",
  "leaveFarmConfirmMessage": "Are you sure you want to leave this farm? You will lose access to all devices and data.",
  "leaveFarmConfirmButton": "Leave Farm",
  "leaveFarmSuccess": "You have left the farm."
}
